import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { FormConfiguration } from '../configuration'
import SelectInput from './SelectInput'

const styles = theme => ({
    root: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: '2px',
        paddingRight: '19px',
        paddingLeft: '10px',
        marginBottom: '1rem',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
            flexDirection: 'column',
            padding: '0',
            paddingRight: '9px'
        }
    }
})

const useStyles = makeStyles(styles)

export default function Selectors() {
    const classes = useStyles()
    return (
        <div className={classes.root} >
            <SelectInput
                label='Paese'
                name='paese'
                menuItems={FormConfiguration.paesi}
            />
            <SelectInput
                label='Citta'
                name='citta'
                menuItems={FormConfiguration.citta}
            />
            <SelectInput
                label='CAP'
                name='cap'
                menuItems={FormConfiguration.cap}
            />
        </div>
    )
}
